import type { SurfaceRecipeId } from './types'

/** DOM data-vjal-recipe marker for a closed recipe id. */
export function recipeMarker(id: SurfaceRecipeId): string {
  return id
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Za-z])(\d)/g, '$1-$2')
    .toLowerCase()
}

export function recipeDataAttrs(id: SurfaceRecipeId): { 'data-vjal-recipe': string } {
  return { 'data-vjal-recipe': recipeMarker(id) }
}

export function actionDataAttrs(id: string): { 'data-vjal-action': string } {
  return { 'data-vjal-action': id }
}

export function proTableDataAttrs(): {
  'data-vjal-pro-table': string
  'data-vjal-recipe': string
} {
  return {
    'data-vjal-pro-table': '',
    'data-vjal-recipe': recipeMarker('ProTable-1'),
  }
}

export const AUTH_ACTIONS = {
  requestOtp: 'auth.request-otp',
  verifyOtp: 'auth.verify-otp',
  logout: 'auth.logout',
} as const
